// const url = 'https://bv-app-backend.beforevault.com/beforevault_backend/login/apis/';

// const url = "https://beforevault-staging-backend.caprover-testing.mtechub.com/";
const url = "https://backend.beforevault.com/";

export default url;